"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault")["default"];

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.setPreloadingProcess = exports.selectPreloadingProcess = exports.selectMeta = exports.selectItems = exports.selectIsNotFound = exports.selectInExportProcess = exports.resetStateAction = exports.refreshTwoFARequestSuccessAction = exports.refreshTwoFARequestFailAction = exports.refreshTwoFARequestAction = exports.reducer = exports.notFoundAction = exports.name = exports.getTokenDataRequestSuccessAction = exports.getTokenDataRequestFailAction = exports.getTokenDataRequestAction = exports.getPayoutsRequestSuccessAction = exports.getPayoutsRequestFailAction = exports.getPayoutsRequestAction = exports.exportPayoutsRequestSuccessAction = exports.exportPayoutsRequestFailAction = exports.exportPayoutsRequestAction = exports.createPayoutsRequestSuccessAction = void 0;

var _toConsumableArray2 = _interopRequireDefault(require("@babel/runtime/helpers/esm/toConsumableArray"));

var _toolkit = require("@reduxjs/toolkit");

var REDUCER_NAME = 'module/payouts';
var INITIAL_STATE = {
  items: [],
  meta: {},
  error: null,
  token: null,
  inExportProcess: false,
  isNotFound: false
};
var slice = (0, _toolkit.createSlice)({
  name: REDUCER_NAME,
  initialState: INITIAL_STATE,
  reducers: {
    resetStateAction: function resetStateAction(state) {
      state['items'] = [];
      state['meta'] = {};
      state['error'] = null;
      state['token'] = null;
      state['inExportProcess'] = false;
      state['isNotFound'] = false;
    },
    setPreloadingProcess: function setPreloadingProcess(state, _ref) {
      var payload = _ref.payload;
      state['preloadingProcess'] = payload;
    },
    createPayoutsRequestSuccessAction: function createPayoutsRequestSuccessAction(state, _ref2) {
      var payload = _ref2.payload;

      if (state['meta']['paging'] && state['meta']['paging']['skip'] > 0) {
        return void 0;
      }

      state['items'] = [payload].concat((0, _toConsumableArray2["default"])(state['items'].slice(0, 9)));
    },
    getPayoutsRequestAction: function getPayoutsRequestAction(state) {},
    getPayoutsRequestFailAction: function getPayoutsRequestFailAction(state) {},
    getPayoutsRequestSuccessAction: function getPayoutsRequestSuccessAction(state, _ref3) {
      var payload = _ref3.payload;
      state['items'] = payload['data'];
      state['meta'] = payload['meta'];
    },
    exportPayoutsRequestAction: function exportPayoutsRequestAction(state) {
      state['inExportProcess'] = true;
    },
    exportPayoutsRequestFailAction: function exportPayoutsRequestFailAction(state) {
      state['inExportProcess'] = false;
    },
    exportPayoutsRequestSuccessAction: function exportPayoutsRequestSuccessAction(state) {
      state['inExportProcess'] = false;
    },
    notFoundAction: function notFoundAction(state) {
      state['isNotFound'] = true;
    }
  }
});
var _slice$actions = slice['actions'],
    resetStateAction = _slice$actions.resetStateAction,
    setPreloadingProcess = _slice$actions.setPreloadingProcess,
    createPayoutsRequestSuccessAction = _slice$actions.createPayoutsRequestSuccessAction,
    getPayoutsRequestAction = _slice$actions.getPayoutsRequestAction,
    getPayoutsRequestFailAction = _slice$actions.getPayoutsRequestFailAction,
    getPayoutsRequestSuccessAction = _slice$actions.getPayoutsRequestSuccessAction,
    getTokenDataRequestAction = _slice$actions.getTokenDataRequestAction,
    getTokenDataRequestFailAction = _slice$actions.getTokenDataRequestFailAction,
    getTokenDataRequestSuccessAction = _slice$actions.getTokenDataRequestSuccessAction,
    exportPayoutsRequestAction = _slice$actions.exportPayoutsRequestAction,
    exportPayoutsRequestFailAction = _slice$actions.exportPayoutsRequestFailAction,
    exportPayoutsRequestSuccessAction = _slice$actions.exportPayoutsRequestSuccessAction,
    refreshTwoFARequestAction = _slice$actions.refreshTwoFARequestAction,
    refreshTwoFARequestFailAction = _slice$actions.refreshTwoFARequestFailAction,
    refreshTwoFARequestSuccessAction = _slice$actions.refreshTwoFARequestSuccessAction,
    notFoundAction = _slice$actions.notFoundAction;
exports.notFoundAction = notFoundAction;
exports.refreshTwoFARequestSuccessAction = refreshTwoFARequestSuccessAction;
exports.refreshTwoFARequestFailAction = refreshTwoFARequestFailAction;
exports.refreshTwoFARequestAction = refreshTwoFARequestAction;
exports.exportPayoutsRequestSuccessAction = exportPayoutsRequestSuccessAction;
exports.exportPayoutsRequestFailAction = exportPayoutsRequestFailAction;
exports.exportPayoutsRequestAction = exportPayoutsRequestAction;
exports.getTokenDataRequestSuccessAction = getTokenDataRequestSuccessAction;
exports.getTokenDataRequestFailAction = getTokenDataRequestFailAction;
exports.getTokenDataRequestAction = getTokenDataRequestAction;
exports.getPayoutsRequestSuccessAction = getPayoutsRequestSuccessAction;
exports.getPayoutsRequestFailAction = getPayoutsRequestFailAction;
exports.getPayoutsRequestAction = getPayoutsRequestAction;
exports.createPayoutsRequestSuccessAction = createPayoutsRequestSuccessAction;
exports.setPreloadingProcess = setPreloadingProcess;
exports.resetStateAction = resetStateAction;

var selectMeta = function selectMeta(state) {
  return state[REDUCER_NAME]['meta'];
};

exports.selectMeta = selectMeta;

var selectItems = function selectItems(state) {
  return state[REDUCER_NAME]['items'];
};

exports.selectItems = selectItems;

var selectInExportProcess = function selectInExportProcess(state) {
  return state[REDUCER_NAME]['inExportProcess'];
};

exports.selectInExportProcess = selectInExportProcess;

var selectPreloadingProcess = function selectPreloadingProcess(state) {
  return state[REDUCER_NAME]['preloadingProcess'];
};

exports.selectPreloadingProcess = selectPreloadingProcess;

var selectIsNotFound = function selectIsNotFound(state) {
  return state[REDUCER_NAME]['isNotFound'];
};

exports.selectIsNotFound = selectIsNotFound;
var name = slice['name'];
exports.name = name;
var reducer = slice['reducer'];
exports.reducer = reducer;